import { useRef } from 'react';
import { IPage, IProduct } from 'src/common/types/CatalogType';
import { debounce } from 'src/common/helpers/functional';
import {
  sendProductImpressionsEvent,
  IProductWithPosition,
} from 'src/services/googleAnalytics/enhancedEcommerce';

const DELAY_MILISECONDS = 1000;

export const useProductImpressions = (currentPagesNumber: IPage['page'][]) => {
  const productImpressions = useRef<Set<IProductWithPosition>>(new Set());
  const sentProductImpressions = useRef<IProductWithPosition[]>([]);

  const dispatchProductImpressions = debounce(() => {
    const toSend = Array.from(productImpressions.current).filter(
      (product) =>
        !sentProductImpressions.current.find(
          (sentProduct) => product.sku === sentProduct.sku,
        ),
    );

    sendProductImpressionsEvent(toSend, currentPagesNumber);

    sentProductImpressions.current = [
      ...sentProductImpressions.current,
      ...toSend,
    ];
  }, DELAY_MILISECONDS);

  const clearProductImpressions = () => {
    productImpressions.current.clear();
    sentProductImpressions.current = [];
  };

  const addProductImpression = (product: IProduct, position: number) => {
    productImpressions.current.add({
      ...product,
      position,
    });

    dispatchProductImpressions();
  };

  return {
    addProductImpression,
    clearProductImpressions,
  };
};
